var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgBack = function SvgBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.957C0 7.28.55 6.73 1.228 6.73h25.377a1.228 1.228 0 010 2.456H1.229C.55 9.185 0 8.635 0 7.957z",
    fill: "#E469D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.957c0-.314.12-.628.36-.868L6.91.54a1.229 1.229 0 011.737 1.738l-5.682 5.68 5.682 5.682a1.229 1.229 0 01-1.738 1.737L.36 8.828a1.23 1.23 0 01-.36-.87z",
    fill: "#E469D1"
  })));
};

export default SvgBack;